<template>
	<div class="wrap">
		<!-- 面包屑导航区 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item class="test">旗下品牌设置</el-breadcrumb-item>
		</el-breadcrumb>
		
		<el-card>
			<el-tag type="danger">旗下品牌页面如需修改，请联系前端修改</el-tag>
		</el-card>
	</div>
</template>

<script>
	export default{
		
	}
</script>

<style lang="less" scoped>
	
</style>
